// extracted by mini-css-extract-plugin
export default {"pageTitle":"Pagetitle_pageTitle__+xRBi"};